import { useState } from 'react';
import * as Yup from 'yup';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { sendOtp } from '../../../../api';

const initialValues = {
  email: '',
};

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required')
    .test('domain', 'domain is not allowed', (value) =>
      value?.endsWith('@mapmycrop.com')
    ),
});

export function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values) => {   
      setLoading(true);

      try {
        await sendOtp({ email: values.email });
        navigate('/auth/otpverify', { state: { email: values.email }, replace: true });
      } catch (error) {
        console.error('Error sending OTP:', error);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="d-flex flex-column flex-root vh-100">
      <div className="d-flex flex-column flex-lg-row h-100 w-100">
        <div
          className="d-flex align-items-center justify-content-center w-100"
          style={{
            flex: '7',
            height: '100vh',
          }}
        >
          <img
            src='/assets/media/logos/background.jpg'
            alt="signup"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </div>

        <div
          className="d-flex flex-column justify-content-center align-items-center p-10 w-100"
          style={{
            flex: '3',
            minHeight: '100vh',
            maxHeight: '50vh',
            overflowY: 'auto',
          }}
        >
          <div
            className='fixed'
            style={{
              top: '10%',
              right: '160px',
              transform: 'translateY(-50%)',
              paddingBottom:'4%',
              zIndex: 1000,
            }}
          >
            <img
              alt='logo'
              src='/assets/media/logos/mapmycrop.png'
              style={{
                width: '200px',
                height: '50px',
              }}
            />
          </div>

          <div
            className="bg-body d-flex flex-column flex-center rounded-4 p-10 w-100"
            style={{
              maxWidth: '450px',
              width: '100%',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            }}
          >
            <div className="d-flex flex-center flex-column align-items-stretch w-100">
              <form
                className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
                noValidate
                onSubmit={formik.handleSubmit}
              >
                <div className="text-center mb-10">
                  <h1 className="text-dark fw-bolder mb-3">Forgot Password?</h1>
                  <div className="text-gray-500 fw-semibold fs-6">
                    Enter your email to reset your password.
                  </div>
                </div>

                <div className="fv-row mb-8">
                  {/* <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label> */}
                  <input
                    type="email"
                    placeholder="enter your email"
                    autoComplete="off"
                    {...formik.getFieldProps('email')}
                    className={clsx(
                      'form-control bg-transparent',
                      { 'is-invalid': formik.touched.email && formik.errors.email },
                      {
                        'is-valid': formik.touched.email && !formik.errors.email,
                      }
                    )}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        <span role="alert">{formik.errors.email}</span>
                      </div>
                    </div>
                  )}
                </div>

                <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                  <button
                    type="submit"
                    id="kt_password_reset_submit"
                    className="btn btn-primary me-4"
                    disabled={loading || !formik.isValid}
                  >
                    <span className="indicator-label">
                      {loading ? 'Please wait...' : 'Get OTP'}
                    </span>
                    {loading && (
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    )}
                  </button>
                  <Link to="/auth/login">
                    <button
                      type="button"
                      className="btn btn-light"
                      disabled={loading}
                    >
                      Cancel
                    </button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
